import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '《重庆市城市园林绿化条例》有奖知识竞赛';

const route: RouteConfig = {
  path: '/20200324YLLH',
  name: '20200324YLLH',
  component: () => import('./Home.vue'),
  redirect: '/20200324YLLH/index',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'index',
      component: () => import('./First.vue'),
      name: '20200324YLLH/index',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rank',
      component: () => import('./RankList.vue'),
      name: '20200324YLLH/rank',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'news',
      component: () => import('./RelativeNews.vue'),
      name: '20200324YLLH/news',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'rules',
      component: () => import('./Rules.vue'),
      name: '20200324YLLH/rules',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
